module.exports = __webpack_public_path__ + "images/5225a4eabebda573c6eb12418658f6e3.jpg";